import {
  FetchTokensParamsT,
  FetchTokensGrantTypeE,
  FetchTokensReturnT,
} from "./models";
import { BASE_URL } from "../../../api/config";
import getURIStringFromObj from "./getURIStringFromObj";
import showErrorToast from "../showErrorToast";
import { EndpointsE } from "../../../data/endpoints";

const NO_DATA = [null, null];

// Hard ceiling on the token request. The refresh path holds the global authRefreshMutex while this
// call is in flight, and baseQueryWithReAuth waits on that mutex before EVERY request — so a hung
// /token fetch would otherwise freeze the entire app's query layer indefinitely (e.g. the campaign
// wizard stuck on its loading spinner). The abort guarantees this promise always settles, so the
// mutex is always released.
const TOKEN_REQUEST_TIMEOUT_MS = 15000;

const fetchTokens = async <T extends FetchTokensGrantTypeE>(
  grant_type: T,
  args: FetchTokensParamsT<T>
) => {
  let result: FetchTokensReturnT;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), TOKEN_REQUEST_TIMEOUT_MS);

  try {
    const rawResult = await fetch(`${BASE_URL}${EndpointsE.TOKEN}`, {
      method: "POST",
      body: getURIStringFromObj({ grant_type, ...args }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      signal: controller.signal,
    });

    result = await rawResult.json();

    if (result?.error) {
      showErrorToast(result?.error_description);

      return NO_DATA;
    }
  } catch (e) {
    showErrorToast();
    console.log(e);

    return NO_DATA;
  } finally {
    clearTimeout(timeoutId);
  }

  return result?.access_token
    ? [result?.access_token, result.refresh_token]
    : NO_DATA;
};

export default fetchTokens;
